module.exports = __webpack_public_path__ + "static/media/1nokia.dbe20b8b.png";